import { Children } from 'react';
import PropTypes from 'prop-types';

import CardContent from '@material-ui/core/CardContent';

import { get } from 'utils/lodash';
import { MONTH_YEAR_EN, MONTH_YEAR_ID, PLN_POSTPAID, PLN_POSTPAID_SMALL } from 'settings/constants/payment/utility/common';

import CardContentItem from './Item';

import './style.scss';

const CardContentList = ({ contents, className, itemClassName, receiverName }) => (
  <CardContent className={`content--list ${className}`}>
    {Array.isArray(contents) &&
      Children.toArray(
        contents.map((item, index) => {
          if (!item) return null;

          const info = get(item, 'info', '');
          const rawTitle = get(item, 'title', '');
          const valueColor = get(item, 'valueColor', '');
          const isPLN = receiverName === PLN_POSTPAID || receiverName === PLN_POSTPAID_SMALL;
          const isMonthYear = rawTitle === MONTH_YEAR_EN || rawTitle === MONTH_YEAR_ID;
          const displayTitle = index !== 0 && isPLN && isMonthYear ? '' : rawTitle;

          if (item.isSubtitle) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <span className="content--item subtitle" key={`subtitle-${index}`}>
                {info}
              </span>
            );
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <CardContentItem key={`item-${index}`} title={displayTitle} info={info} className={itemClassName} valueColor={valueColor} />
          );
        })
      )}
  </CardContent>
);

CardContentList.defaultProps = { contents: [], className: '', itemClassName: '', receiverName: '' };

CardContentList.propTypes = {
  contents: PropTypes.array,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  receiverName: PropTypes.string,
};

export default CardContentList;
